export enum WorkitemStatus {
    IN_CQA = "IN_CQA",
    CQA_COMPLETE = "CQA_COMPLETE",
    CQA_APPROVED = "CQA_APPROVED",
}

export const WorkItemStatusToLabel = {
    [WorkitemStatus.IN_CQA]: "To do",
    [WorkitemStatus.CQA_COMPLETE]: "Complete",
    [WorkitemStatus.CQA_APPROVED]: "Approved",
};
